
        var result = require("!!../../../../../../node_modules/css-loader/index.js!../../../../../../node_modules/sass-loader/lib/loader.js!./configure-email.scss");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/components/dataprotection/dataprotection-vc/configure-email/configure-email.scss
// module id = 6JZX
// module chunks = 0